/* global config:true */
/* eslint-disable no-process-env, eqeqeq, no-eq-null */
/* eslint-disable */
// require('dotenv').config();

config = {};

const auth0Default = {
	scope: 'openid profile email offline_access',
	audience: 'https://api.icims.com/v1/'
};

config = {
	imageBaseUrl: 'https://app.textrecruit.com/img',
	assetsUrl: 'https://assets.textrecruit.com',
	auth0: {
		scope: auth0Default.scope,
		audience: auth0Default.audience,
		US: { clientId: 'mJGuY5kl58aGhNI7jXwHNpTyzFGkYnSs', domain: 'login-dev.icimsmco.net' },
		CA: { clientId: 'TODO', domain: 'TODO' },
		EU: { clientId: 'TODO', domain: 'TODO' }
	}
};

const { REACT_APP_ENV } = process.env;

if (REACT_APP_ENV === 'dev') {
	config['launchDarklyId'] = '5b4e60dbc4ea4f2d74b18062';
	config['envShortName'] = 'dev';
	config['apiRootUrl'] = 'https://staging1.textrecruit.com';
	config['apiBaseUrl'] = 'https://staging1.textrecruit.com/api/v1/textrecruit';
	config['lookupApiUrl'] = 'https://lookup.dev.textrecruit.tools';
	config['extensionAppUrl'] = 'https://dev.textrecruit.com/ext-react';
	config['sumo'] = {
		sourceCategory: 'dev/textrecruit/ext'
	};
} else if (REACT_APP_ENV === 'stg') {
	config['launchDarklyId'] = '5b4dde4a4892e62d90d9f3c9';
	config['envShortName'] = 'stg';
	config['apiRootUrl'] = 'https://test1.textrecruit.com';
	config['apiBaseUrl'] = 'https://test1.textrecruit.com/api/v1/textrecruit';
	config['lookupApiUrl'] = 'https://lookup.stg.textrecruit.tools';
	config['webAppUrl'] = 'https://stg.textrecruit.com';
	config['extensionAppUrl'] = 'https://stg.textrecruit.com/ext-react';
	config['sumo'] = {
		sourceCategory: 'dev/textrecruit/ext'
	};
	config.auth0 = {
		...config.auth0,
		domain: 'login-stg.icimsmco.net',
		US: { clientId: '9MCP0WHthB9zQFyeMLqzxpLbdJhJnwTu', domain: 'login-stg.icimsmco.net' }
	};
} else if (REACT_APP_ENV === 'prd') {
	config['launchDarklyId'] = '5b4dde4a4892e62d90d9f3ca';
	config['envShortName'] = 'prd';
	config['apiRootUrl'] = 'https://app1.textrecruit.com';
	config['apiBaseUrl'] = 'https://app1.textrecruit.com/api/v1/textrecruit';
	config['lookupApiUrl'] = 'https://lookup.prd.textrecruit.tools';
	config['webAppUrl'] = 'https://app.textrecruit.com';
	config['extensionAppUrl'] = 'https://app.textrecruit.com/ext-react';
	config['sumo'] = {
		sourceCategory: 'prod/textrecruit/ext'
	};
	config.auth0 = {
		...config.auth0,
		US: { clientId: 'ML51lATf3TTyJ74UNlxgpSn0PjEazaKX', domain: 'login.icims.com' },
		CA: { clientId: 'HHMIhjq5q89ZhrEfOshG3FcVl8m19pf7', domain: 'login.icims.ca' },
		EU: { clientId: 'vll7fc0DQw2Zo67vYrPkJM8hlGo3xHEO', domain: 'login.icims.eu' }
	};
}

config.imageBaseUrl = 'https://app.textrecruit.com/img';

module.exports = config;
